import { useEffect } from "react";
import useCommandFlowStore from "../../store/commandFlowStore";
import { createCallbackRegistry } from "../../utils/callbacks/customCallbackUtils";

export function useInitializeCommandFlow(
  commands,
  translations,
  promptLabel,
  outputDelay,
  typingSpeed,
  promptDelay,
  callbacks = {},
  sentencePause
) {
  const setCommands = useCommandFlowStore((s) => s.setCommands);
  const setTranslations = useCommandFlowStore((s) => s.setTranslations);
  const setPromptLabel = useCommandFlowStore((s) => s.setPromptLabel);
  const setOutputDelay = useCommandFlowStore((s) => s.setOutputDelay);
  const setTypingSpeed = useCommandFlowStore((s) => s.setTypingSpeed);
  const setPromptDelay = useCommandFlowStore((s) => s.setPromptDelay);
  const setSentencePause = useCommandFlowStore((s) => s.setSentencePause);
  const setCallbackRegistry = useCommandFlowStore((s) => s.setCallbackRegistry);

  useEffect(() => {
    // Only set if different to avoid infinite update loop
    if (commands && commands !== useCommandFlowStore.getState().commands)
      setCommands(commands);
    // Only set translations if not empty and not the same reference
    if (
      translations &&
      Object.keys(translations).length > 0 &&
      translations !== useCommandFlowStore.getState().translations
    ) {
      setTranslations(translations);
    }
    if (
      promptLabel !== undefined &&
      promptLabel !== useCommandFlowStore.getState().promptLabel
    )
      setPromptLabel(promptLabel);
    if (
      outputDelay !== undefined &&
      outputDelay !== useCommandFlowStore.getState().outputDelay
    )
      setOutputDelay(outputDelay);
    if (
      typingSpeed !== undefined &&
      typingSpeed !== useCommandFlowStore.getState().typingSpeed
    )
      setTypingSpeed(typingSpeed);
    if (
      promptDelay !== undefined &&
      promptDelay !== useCommandFlowStore.getState().promptDelay
    )
      setPromptDelay(promptDelay);
    if (
      sentencePause !== undefined &&
      sentencePause !== useCommandFlowStore.getState().sentencePause
    )
      setSentencePause(sentencePause);
  }, [
    commands,
    translations,
    promptLabel,
    outputDelay,
    typingSpeed,
    promptDelay,
    sentencePause,
    setCommands,
    setTranslations,
    setPromptLabel,
    setOutputDelay,
    setTypingSpeed,
    setPromptDelay,
    setSentencePause,
  ]);

  // Handle callbacks in a separate effect to avoid infinite loops
  useEffect(() => {
    if (callbacks && Object.keys(callbacks).length > 0) {
      const currentRegistry = useCommandFlowStore.getState().callbackRegistry;

      // Only update if callbacks have actually changed
      const callbackKeys = Object.keys(callbacks).sort().join(",");
      const currentCallbacks = currentRegistry?.getAll
        ? currentRegistry.getAll()
        : {};
      const currentKeys = Object.keys(currentCallbacks).sort().join(",");

      if (callbackKeys !== currentKeys) {
        console.log("🔄 Updating callback registry with keys:", callbackKeys);
        const registry = createCallbackRegistry(callbacks);
        setCallbackRegistry(registry);
      }
    }
  }, [callbacks, setCallbackRegistry]);
}
